<template>
  <qx-card-form title="GPS设备信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="140px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        stateOptions: [],
        orgIdOptions: [],
        form: [
          {
            label: '易流',
            value: 'yiLiuSelected',
            type: 'radio',
            default: false,
            options: [
              {
                label: '是',
                value: true,
              },
              {
                label: '否',
                value: false,
              },
            ],
            onChange: () => {
              this.handleYLChange();
            },
          },
          {
            label: '公钥',
            value: 'ylPublicKey',
            type: 'input',
            hide: true,
          },
          {
            label: '密钥',
            value: 'ylPrivateKey',
            type: 'input',
            hide: true,
          },
          {
            label: 'G7',
            value: 'g7Selected',
            type: 'radio',
            default: false,
            options: [
              {
                label: '是',
                value: true,
              },
              {
                label: '否',
                value: false,
              },
            ],
            onChange: () => {
              this.handleG7Change();
            },
          },
          {
            label: '机构代码',
            value: 'g7Code',
            type: 'input',
            hide: true,
          },
        ],
        rules: {
          ylPublicKey: [ // 公钥
            { required: true, message: '请输入公钥', trigger: 'blur' },
          ],
          ylPrivateKey: [ // 密钥
            { required: true, message: '请输入密钥', trigger: 'blur' },
          ],
          g7Code: [ // 机构代码
            { required: true, message: '请输入机构代码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async handleYLChange () {
      const yiLiuSelected = await this.$refs.baseForm.getVal('yiLiuSelected');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !yiLiuSelected,
        names: ['ylPublicKey', 'ylPrivateKey'],
      });
    },

    async handleG7Change () {
      const g7Selected = await this.$refs.baseForm.getVal('g7Selected');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !g7Selected,
        names: ['g7Code'],
      });
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        if (!formData.yiLiuSelected) {
          delete formData.ylPublicKey;
          delete formData.ylPrivateKey;
        }
        if (!formData.g7Selected) {
          delete formData.g7Code;
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    init (data = {}) {
      if (data.ylPublicKey) {
        data.yiLiuSelected = true;
      } else {
        data.yiLiuSelected = false;
      }
      if (data.g7Code) {
        data.g7Selected = true;
      } else {
        data.g7Selected = false;
      }
      this.$refs.baseForm.setVal(data);
      this.handleYLChange();
      this.handleG7Change();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
